import { CampaignType } from '../../../constants/marketingCampaign'
import { CampaignDefinition } from '../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { freeDeliveryDefinition } from './freeDeliveryAfterThreshold'
import { fixedAmountDiscountDefinition } from './fixedAmountDiscountAfterThreshold'
import { globalProductDiscountDefinition } from './globalProductDiscountAfterThreshold'
import { productDiscountDefinition } from './productDiscount'
import { productDiscountAfterThresholdDefinition } from './productDiscountAfterThreshold'
import { buyOneGetOneProductDefinition } from './buyOneGetOneProduct'
import { buyOneGetOneDifferentProductDefinition } from './buyOneGetOneDifferentProduct'
import { buyNGetMCheapestAtDiscountDefinition } from './buyNGetMCheapestAtDiscount'

export const CAMPAIGN_REGISTRY: Record<CampaignType, CampaignDefinition<any>> = {
	[CampaignType.FREE_DELIVERY_AFTER_THRESHOLD]: freeDeliveryDefinition,
	[CampaignType.FIXED_AMOUNT_DISCOUNT_AFTER_THRESHOLD]: fixedAmountDiscountDefinition,
	[CampaignType.GLOBAL_PRODUCT_DISCOUNT_AFTER_THRESHOLD]: globalProductDiscountDefinition,
	[CampaignType.PRODUCT_DISCOUNT]: productDiscountDefinition,
	[CampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD]: productDiscountAfterThresholdDefinition,
	[CampaignType.BUY_ONE_GET_ONE_PRODUCT]: buyOneGetOneProductDefinition,
	[CampaignType.BUY_ONE_GET_ONE_DIFFERENT_PRODUCT]: buyOneGetOneDifferentProductDefinition,
	[CampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT]: buyNGetMCheapestAtDiscountDefinition,
}

export function getCampaignDefinition(type: CampaignType): CampaignDefinition<any> {
	return CAMPAIGN_REGISTRY[type]
}
